import { render, staticRenderFns } from "./auth-manage.vue?vue&type=template&id=763f7e52&scoped=true"
import script from "./auth-manage.vue?vue&type=script&lang=js"
export * from "./auth-manage.vue?vue&type=script&lang=js"
import style0 from "./auth-manage.vue?vue&type=style&index=0&id=763f7e52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f7e52",
  null
  
)

export default component.exports